<atn-ds-page>
  <atn-ds-table [config]="tableConfig">
    <ng-container customTools>
      <i
        class="atn-icon atn-funnel atn-blue"
        (click)="changeFilterSlideoutVisibilityHandler(true)"
      ></i>
    </ng-container>
  </atn-ds-table>
</atn-ds-page>

<!-- ------------------------------- Dialogs ------------------------------- -->

@if (slideoutRecord.asSignal()) {
  <atn-ds-slideout-overlay
    [name]="slideoutNameSg()"
    [hasFullHeight]="false"
    (backdropClicked)="
      slideoutCloseBtnClickHandler('EditMappingSlideout.Backdrop.Clicked')
    "
  >
    <i
      class="atn-icon atn-close atn-red"
      actions
      (click)="
        slideoutCloseBtnClickHandler('EditMappingSlideout.CloseBtn.Clicked')
      "
    ></i>
    <atn-rate-gl-record-slideout />
  </atn-ds-slideout-overlay>
}

@if (presentFilterSlideoutSg()) {
  <atn-ds-slideout-overlay
    name="General Ledger Filter"
    [hasFullHeight]="false"
    (backdropClicked)="changeFilterSlideoutVisibilityHandler(false)"
  >
    <i
      class="atn-icon atn-close atn-red"
      actions
      (click)="changeFilterSlideoutVisibilityHandler(false)"
    ></i>
    <atn-rate-gl-filter-slideout
      (closeClick)="changeFilterSlideoutVisibilityHandler(false)"
    />
  </atn-ds-slideout-overlay>
}

<atn-rate-rule-slideout />

@if (
  this.ruleEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  <atn-ds-confirmation-overlay
    description="Are you sure that you want to delete rule?"
    title="Delete Rule"
    (confirm)="deleteRuleConfirmHandler()"
    (cancel)="deleteRuleCancelHandler()"
  />
}
